import * as Sentry from "@sentry/react";
import ErrorFallback from "pages/error";
import { frontendLogger } from "helpers/frontendLogger";
import type { ReactNode } from "react";

type AppErrorBoundaryProps = {
  children: ReactNode;
  scope: string;
};

const AppErrorBoundary = ({ children, scope }: AppErrorBoundaryProps) => (
  <Sentry.ErrorBoundary
    fallback={({ error, componentStack, eventId, resetError }) => (
      <ErrorFallback
        error={error}
        componentStack={componentStack}
        eventId={eventId}
        resetError={resetError}
        scope={scope}
      />
    )}
    beforeCapture={(sentryScope) => {
      sentryScope.setTag("location", scope);
      sentryScope.setTag("service", "incomlend-frontend");
    }}
    onError={(error, _componentStack, eventId) => {
      frontendLogger.error("Unhandled React rendering error", {
        component: "react",
        operation: "error_boundary",
        outcome: "failed",
        error_type: error instanceof Error ? error.name : "UnknownError",
        event_id: eventId,
      });
    }}
  >
    {children}
  </Sentry.ErrorBoundary>
);

export default AppErrorBoundary;
